export default "__VITE_ASSET__BLi6eLMe__"